import { defineNuxtPlugin, useRoute } from '#imports'
import { useCart } from '~/composables/useCart'
import { useUserStore } from '~/store/user'

export default defineNuxtPlugin(async () => {
  // Only initialize the cart on the client-side
  if (process.client) {
    const route = useRoute()
    const userStore = useUserStore()

    // Skip cart loading on login pages
    const isLoginRoute =
      route.path.includes('/login') || route.path.includes('/amazon/login')

    // Only load cart if we're logged in and not on a login page
    if (userStore.loggedIn && !isLoginRoute) {
      const { load: loadCart } = useCart()
      await loadCart()
    }
  }
})
